<app-card-lg [title]="'Inventory'">
  <div *appLoading="loading$ | async"></div>
  @if (!(loading$ | async)) {
    @for (product of (inventory$ | async); track product) {
      <app-inventory-list-item [product]="product"></app-inventory-list-item>
    }
  }
</app-card-lg>
